import { useEffect, useState } from 'react';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { Feedback, FeedbackType } from '@/modules/perseo-billing/components';

export const GiftCardFeedbacks = () => {
  const [giftCardMessage, setGiftCardMessage] = useState('');

  const billing = useAppSelector((state) => state.billing);
  const totalItems = billing?.billingSummary?.summary?.items?.length;
  const productsNotCompatibleWithGC =
    billing?.productsNotCompatibleWithGC?.length;

  useEffect(() => {
    if (productsNotCompatibleWithGC === 1) {
      setGiftCardMessage(
        'Tus producto no se pueden pagar con Gift Card por ser Marketplace o porque el tipo de Gift Card no lo permite. Por favor, elige otro medio de pago o elimina los productos del carro.'
      );
    }
    if (productsNotCompatibleWithGC > 1) {
      setGiftCardMessage(
        `${productsNotCompatibleWithGC} de tus ${totalItems} productos no se pueden pagar con Gift Card por ser Marketplace o porque el tipo de Gift Card no lo permite. Por favor, elige otro medio de pago o elimina los productos del carro`
      );
    }
  }, [productsNotCompatibleWithGC, totalItems]);

  return (
    <>
      {productsNotCompatibleWithGC > 0 && (
        <Feedback
          type={FeedbackType.WARNING}
          title="Revisa tus productos"
          subtitle={giftCardMessage}
        />
      )}
    </>
  );
};
